<template>
  <div class="fe-flex">
    <div class="fe-text-heading-s fe-mb-xs">
      {{ averageRating }}<span>/5</span>
    </div>
    <div class="fe-mb-xxs lg:fe-mb-xs">
      <StarRating
        :readOnly="true"
        :initialRating="averageRating"
        size="s"
        :partialSupport="true"
      />
    </div>
  </div>
</template>

<script>
  import StarRating from "@/components/DesignSystem/StarRating/StarRating.vue"

  export default {
    components: { StarRating },
    name: "RatingStats",
    inject: ["globalState"],
    computed: {
      averageRating() {
        return this.globalState.avgRating || 0
      },
    },
  }
</script>
